import gql from 'graphql-tag';

export const updateUserMutation = gql`
  mutation UpdateUser($userId: Int!, $firstName: String, $lastName: String) {
    updateUser(userId: $userId, firstName: $firstName, lastName: $lastName) {
      id
      displayName
      firstName
      lastName
    }
  }
`;
